import { fetchApi } from "../../tools"

export const getSedes = async (urlCursos, send, headers) => {
  const response = await fetchApi({
    url: `${urlCursos}/utils/busquedas`,
    headers: headers,
    content: {
      Opcion: "SEDES"
    }
  })
  
  send("CARGAR_SEDES", { sedes: response.msg })
}


export const getCursos = async (urlCursos, headers, idCurso, idSede) => {
  const response = await fetchApi({
    url: urlCursos + "/utils/busquedas",
    headers: headers,
    content: {
      Opcion: "CURSOS",
      IdCatalogo: idCurso,
      IdSede: idSede,
    }
  })
  
  return response.msg
  //send("CARGAR_CURSOS", {cursos: response.msg})
}

export const postCursos = async (urlCursos, headers, datos, setModal, send, setLoading, modalidad, opcion) => {
  setLoading(true)
  // console.log('headers', headers)
  // console.log('datos:', datos)
  datos.Modalidad = modalidad
  const data = { ...datos }
  
  // data.Cursos.Cursos[0]["Key"]
  await data.Cursos.Cursos.forEach((curso, index) => {
    
    if (curso?.Cargos[0]?.Header?.IdSede) { curso.IdSede = curso?.Cargos[0]?.Header?.IdSede }
    //curso.IdSede = curso?.Cargos[0]?.Header?.IdSede // para adjuntar el header que se le puso en el header
    if (curso?.Cargos[0]?.Header) delete curso?.Cargos[0]?.Header
    delete curso["Key"]
    curso.Cargos.forEach(el => {
      delete el.Key
      delete el.IndexCargo
      delete el.IndexCurso
      delete el.IndexHorario
      //delete el.Seleccionado
      delete el.IdHorario
      delete el.Index
      delete el.DescripcionPlan
      delete el.sortIndex
      //delete el?.IdSede
      delete el?.["Paga"]
      //delete el?.["Pagado"]
      delete el?.["Saldo"]
      //delete el?.["Cobrado"]
      delete el?.["FechaCobrado"]
      delete el?.["ReciboCobro"]
      el.Descuento = el.Cupones.reduce((prev, next) => prev + next.ValorCupon, 0)
      el.Cupon = 1
      
      if (!el?.precioAnterior) {
        el["precioAnterior"] = el.Valor
        el.Valor = el.precioAnterior - el.Descuento
      }
    }
    )
  })
  // JSON.stringify(datos)
  

  let opcionUrl = '/inscripciones/asigna_cursos'

  if (opcion === 1) {
    opcionUrl = '/inscripciones/traslado_cursos'
  }

  if (opcion === 2) {
    opcionUrl = '/inscripciones/traslado_fondos'
  }

  if (opcion === 3) {
    opcionUrl = '/inscripciones/devolucion_cursos'
  }

  
  send("GUARDAR_CURSOS", { cursos: data.Cursos })
  const response = await fetchApi({
    url: urlCursos + opcionUrl,
    headers: headers,
    method: 'POST',
    content:
      datos
  })
  
  if (response.msg[0]["IdSolicitud"]) {
    
    //send("GUARDAR_CARNET", { carnet: response.msg[0]["IdSolicitud"] });
    if (opcion === 2) {
      send("ACEPTAR_TRASLADO_FONDOS")
    } else {
      send("ACEPTAR")
    }
  } else {
    setModal({
      show: true,
      msg: "La solicitud no existe",
      ok: false,
    })
  }
  setLoading(false)

}
